import React from "react";
import { Box, Button, alpha, useTheme } from "@mui/material";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";

const TAB_CONFIG = [
  { value: "messages", labelKey: "tabMessages", icon: ForumOutlinedIcon },
  { value: "tasks", labelKey: "tabTasks", icon: ViewKanbanOutlinedIcon },
];

const TeamSpacePaneTabs = ({ value, onChange, t, inline = false }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: inline ? 0 : { xs: 1.25, sm: 2 },
        pb: inline ? 0 : { xs: 0.5, sm: 0.625 },
        pt: inline ? 0 : 0,
        flexShrink: 0,
      }}
    >
      <Box
        role="tablist"
        aria-label={t("spacePaneTabsLabel")}
        sx={{
          display: "inline-flex",
          p: "2px",
          borderRadius: 1.5,
          gap: "2px",
          bgcolor: alpha(
            theme.palette.text.primary,
            theme.palette.mode === "dark" ? 0.1 : 0.06
          ),
          border: `1px solid ${alpha(theme.palette.divider, 0.28)}`,
        }}
      >
        {TAB_CONFIG.map(({ value: tabValue, labelKey, icon: Icon }) => {
          const active = value === tabValue;
          return (
            <Button
              key={tabValue}
              role="tab"
              aria-selected={active}
              onClick={() => onChange(tabValue)}
              startIcon={<Icon sx={{ fontSize: "14px !important" }} />}
              sx={{
                px: { xs: 1, sm: 1.25 },
                py: 0.25,
                minHeight: 26,
                minWidth: 0,
                borderRadius: 1.25,
                textTransform: "none",
                fontWeight: active ? 700 : 600,
                fontSize: "0.75rem",
                letterSpacing: 0,
                lineHeight: 1.1,
                color: active ? "primary.main" : "text.secondary",
                bgcolor: active ? "background.paper" : "transparent",
                boxShadow: active
                  ? `0 1px 2px ${alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.28 : 0.06)}`
                  : "none",
                transition: "background-color 0.15s, color 0.15s, box-shadow 0.15s",
                "&:hover": {
                  bgcolor: active
                    ? "background.paper"
                    : alpha(theme.palette.action.hover, 0.05),
                },
                "& .MuiButton-startIcon": {
                  mr: 0.4,
                  ml: 0,
                },
              }}
            >
              {t(labelKey)}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

export default TeamSpacePaneTabs;
